<template>
  <!-- 测试上传组件 -->
  <div v-loading="loading" id="test">
    <div class="word">
      <!-- <MakerSpaceWord/> -->
      <!-- <MakerSpaceWordShow/> -->
      <!-- 创客专项资金及项目申请表（个人创客） -->
      <!-- <markerFundWord/> -->
      <markeractivityWord/>   
    </div>

    <!-- <div>
      <BeUpload
        @getFile="getFile"
        :navName="'测试按钮'"
        :accept="accept"
      ></BeUpload>
    </div>
    <div style="background: blue">
      <div style="width:300px;height:100%">
        <img src="../assets/img/sclogo3.png" alt="" style="width:300px;height:100%"/>
      </div>
    </div>
    <el-button @click="Excel()">Excel文件测试按钮</el-button> -->
  </div>
</template>

<script>
// import MakerSpaceWord from '../components/MakerSpaceWord.vue'
import BeUpload from "../components/tool/beUpload.vue";
import getExcel from "@/components/tool/getExcel";
import MakerSpaceWord from '@/components/MakerSpaceWord.vue'
import MakerSpaceWordShow from '@/components/MakerSpaceWordShow.vue'
import markerFundWord from '@/components/markerFundWord.vue'
import markeractivityWord from '@/components/markeractivityWord.vue'
export default {
  components: {
    BeUpload,
    MakerSpaceWord,
    MakerSpaceWordShow,
    markerFundWord,
    markeractivityWord,
  },
  data() {
    return {
      accept: "*",
      loading:false,
    };
  },
  methods: {
    getFile(val) {
      console.log(val);
    },
    Excel(){
      getExcel("数据")
    }
  },
};
</script>

<style lang="less" scoped>
#test{
  width: 100vw;
  display: flex;
  // background:blue;
  justify-content: center;
}
.word{
  width: 1600px;
  margin-left: 40px;
  height: auto;
}
</style>